import { Route } from 'vue-router';
import { DefaultSearchVariables } from '@root/modules/search/types/SearchVariables';

const normalizeSearchObj = (searchObj: Route['query']): DefaultSearchVariables => {
  try {
    const searchEntries = Object.entries(searchObj);
    const searchParams = searchEntries.reduce((acc, [key, value]) => {
      const valueString = String(value || '');

      if (key && valueString) {
        return { ...acc, [key]: decodeURIComponent(String(value)) };
      } else {
        return acc;
      }
    }, {});

    return searchParams;
  } catch {
    return {};
  }
};

export { normalizeSearchObj };
